import { Brand, Generation, Model } from "@app/store/types";
export interface FormFile {
    url: string;
    filename: string;
}
export interface PostFormState {
    selectedBrand?: Brand;
    selectedModel?: Model;
    selectedGeneration?: Generation;

    selectedStreet?: string;
    selectedGenerationUpdated?: boolean;
    selectedGenerationValid?: boolean;

    setSelectedDrive?: string;

    selectedEngine?: string;
    selectedEngineValid?: boolean;
    selectedEngineUpdated?: boolean;

    selectedDrive?: string;
    selectedDriveUpdated: boolean;
    selectedDriveValid: boolean;

    selectedYear?: number;
    selectedYearUpdated?: boolean;
    selectedYearValid: boolean;
    yearErrMessage?: string;

    selectedMileage?: number;
    mileageUpdated: boolean;
    mileageValid: boolean;

    selectedEnginePower?: number;

    selectedColor?: string;
    selectedColorUpdated?: boolean;
    selectedColorValid?: boolean;

    selectedDescription?: string;
    selectedDescriptionUpdated?: boolean;
    selectedDescriptionValid?: boolean;
    selectedDescriptionErrMessage?: string;

    selectedPrice?: number;
    selectedPriceUpdated?: boolean;
    selectedPriceValid?: boolean;
    selectedPriceErrMessage?: string;

    selectedCity?: string;
    selectedCountry?: string;

    selectedPhone?: string;
    selectedPhoneUpdated?: boolean;
    selectedPhoneValid?: boolean;
    selectedPhoneErrMessage?: string;

    selectedName?: string;
    selectedNameUpdated?: boolean;
    selectedNameValid?: boolean;
    selectedNameErrMessage?: string;

    selectedSellerType?: string;

    selectedBodyType?: string;
    selectedBodyTypeUpdated: boolean;
    selectedBodyTypeValid: boolean;

    selectedPics?: FormFile[];
    selectedOwnersQnt?: number;
    selectedOwnersQntUpdated?: boolean;
    selectedOwnersQntValid?: boolean;
    selectedOwnersQntErrMessage?: string;

    selectedTransmission?: string;
    selectedTransmissionUpdated?: boolean;
    selectedTransmissionValid?: boolean;

    selectedWheel?: string;
    selectedWheelUpdated?: boolean;
    selectedWheelValid?: boolean;

    horsePower?: number;
    horsePowerUpdated?: boolean;
    horsePowerValid?: boolean;
    horsePowerErrMessage?: string;

    vin?: string;
    vinUpdated?: boolean;
    vinValid?: boolean;
    vinErrMessage?: string;

    autoFilled: boolean;
    characteristicsFilled: boolean;
    photoFilled: boolean;
    descriptionFilled: boolean;
    contactsFilled: boolean;
    placeFilled: boolean;
    priceFilled: boolean;

    isFilled: boolean;

    coordinates: number[];
}

export type EditPostStoreName = "postForm" | "editForm" | "analyticsForm";

export const initialState: PostFormState = {
    coordinates: [],
    selectedGenerationUpdated: false,
    selectedGenerationValid: false,
    autoFilled: false,
    characteristicsFilled: false,
    photoFilled: false,
    descriptionFilled: false,
    contactsFilled: false,
    placeFilled: false,
    priceFilled: false,
    isFilled: false,
    selectedPics: [],
    selectedSellerType: "individual",
    selectedYearUpdated: false,
    selectedYearValid: false,

    selectedPriceErrMessage: "Не заполнено",

    selectedOwnersQntErrMessage: "Не заполнено",

    selectedBodyTypeUpdated: false,
    selectedBodyTypeValid: false,

    horsePowerUpdated: false,
    horsePowerValid: false,

    vinUpdated: false,
    vinValid: false,

    mileageUpdated: false,
    mileageValid: false,

    selectedDescriptionUpdated: false,
    selectedDescriptionValid: false,

    selectedPriceUpdated: false,
    selectedPriceValid: false,

    selectedNameUpdated: false,
    selectedNameValid: false,

    selectedPhoneUpdated: false,
    selectedPhoneValid: false,

    selectedColorUpdated: false,
    selectedColorValid: false,

    selectedEngineValid: false,
    selectedEngineUpdated: false,

    selectedDriveUpdated: false,
    selectedDriveValid: false,

    selectedTransmissionUpdated: false,
    selectedTransmissionValid: false,

    selectedWheelUpdated: false,
    selectedWheelValid: false,

    selectedNameErrMessage: "Не заполнено",
    selectedPhoneErrMessage: "Не заполнено",
    selectedDescriptionErrMessage: "Не заполнено"
};

export type StoreName = "postForm" | "editForm";